import React, { useState, useEffect } from 'react';
import styles from './EditableField.module.css'


const EditableField = ({ initialData, isEditing, onChange, customClassName = '' }) => {
  const [data, setData] = useState(initialData || '');

  useEffect(() => {
    setData(initialData || '');
  }, [initialData]);

  const handleChange = (event) => {
    setData(event.target.value);
    onChange(event.target.value);
  };

  return (
    <span className={styles.container}>
      {isEditing ? (
        <>
          <span className={styles.fields}>
            <input
              type="text"
              value={data}
              onChange={handleChange}
              className={`${styles.fieldinputs} ${customClassName}`}
            />
          </span>
        </>
      ) : (
        <>
          <span className={`${styles.fieldinputs} ${customClassName}`}>{data}</span>
        </>
      )}
    </span>
  );
};

export default EditableField;
